import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap/modal';

import { OfficeFieldsValuesObj } from '../../../models/office-data.model';
import { OfficeFormControlComponent } from '../../office-form/office-form-control/office-form-control.component';
import { OfficeFormHelperService } from '../../office-form/office-form-helper.service';
import { IModalFormItem } from '@pages/office/models/modal-form-metadata.model';

@Component({
  selector: 'app-form-events-modal',
  templateUrl: 'form-events-modal.component.html',
  styleUrls: ['form-events-modal.component.scss'],
  standalone: true,
  imports: [OfficeFormControlComponent, ReactiveFormsModule],
  providers: [OfficeFormHelperService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormEventsModalComponent implements OnInit {
  @Input() title: string;
  @Input() officeFields: IModalFormItem[];

  public onConfirm = new EventEmitter<OfficeFieldsValuesObj | null>();
  public eventsForm: FormGroup;
  public mappedFieldToFormItems$ = signal([]);

  private bsModalRef = inject(BsModalRef);
  private formBuilder = inject(FormBuilder);

  ngOnInit(): void {
    this.buildForm();
  }

  public confirm(): void {
    this.onConfirm.next(this.eventsForm.getRawValue());
    this.bsModalRef.hide();
  }

  public close(): void {
    this.onConfirm.next(null);
    this.bsModalRef.hide();
  }

  private buildForm(): void {
    const controls = {};
    const mappedFieldToFormItems = this.officeFields.map(field => {
      const control = this.formBuilder.control({ value: field.formValue, disabled: field.IsReadOnly });
      controls[field.Seq] = control;
      return { ...field, RecordLabel: field.Label, VistaFormItem: { ColumnName: field.Label, Req: field.Required } };
    });
    this.mappedFieldToFormItems$.set(mappedFieldToFormItems);
    this.eventsForm = this.formBuilder.group(controls);
  }
}
